import { SHA256 } from "crypto-js";
import { CheckInUserPropertiesDto, VpvEventInput } from "../dto/vpv.dto";
import {
  CheckInInteractionsEventDto,
  CheckInInteractionsEventParamsDto,
} from "../dto/interactions.dto";

interface InteractionsEventInput extends VpvEventInput {
  evento_interactivo_categoria: string;
  evento_interactivo_accion: string;
  evento_interactivo_etiqueta: string;
}

export const CheckInInteractionsEvent = (
  data: InteractionsEventInput
): CheckInInteractionsEventDto => {
  const {
    micrositio,
    page_path,
    page_type,
    page_title,
    homemarket,
    environment,
    login,
    evento_interactivo_categoria,
    evento_interactivo_accion,
    evento_interactivo_etiqueta,
    user_props = {},
    product_name,
  } = data;

  const event_params = new CheckInInteractionsEventParamsDto();
  event_params.micrositio = micrositio;
  event_params.page_path = page_path;
  event_params.page_type = page_type;
  event_params.page_title = page_title;
  event_params.homemarket = homemarket;
  event_params.environment = environment;
  event_params.login = login;
  event_params.evento_interactivo_categoria = evento_interactivo_categoria;
  event_params.evento_interactivo_accion = evento_interactivo_accion;
  event_params.evento_interactivo_etiqueta = evento_interactivo_etiqueta;
  product_name && (event_params.product_name = product_name);
  const dto = new CheckInInteractionsEventDto();
  dto.event = "interacciones";
  dto.event_params = event_params;

  if (user_props && user_props.pas_dni) {
    const user_properties = new CheckInUserPropertiesDto();
    user_properties.pas_dni_hashed = SHA256(user_props.pas_dni).toString();
    if (user_props.birthday) {
      user_properties.birthday = user_props.birthday;
    }
    user_properties.user_type = user_props.user_type || "guest";

    dto.user_properties = user_properties;
  }

  return dto;
};
